'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Backbone = require('dibs-backbone');
var DocumentList;
var relayDocuments = function (method) {
    return function () {
        var docs = this.get('documents');
        return docs[method].apply(docs, arguments);
    };
};
/**
 * Generic model to represent a list and its metadata.
 *
 * Example:
 * {
 *    apiType: 'documentList',
 *    metadata: { x: 1, y: 2 },
 *    documents: [ model, model, model ]
 * }
 *
 * Uses: To use this in a relation, you have to specify the model to be used in the
 * documents attribute of the document list.  So if your documents is an array of
 * users, you would do the following:
 *
 * UserDocumentList = DocumentList.extend({
 *    model: User
 * });
 *
 * ...
 * relations: [
 *    {
 *       key: 'users',
 *       relatedModel: UserDocumentList
 *    }
 * ]
 *
 */
DocumentList = SoaModel.extend({
    model: SoaModel,
    relations: [
        {
            key: 'documents',
            relatedModel: function () {
                return this.model;
            },
            type: Backbone.Many
        },
        {
            key: 'metadata',
            relatedModel: SoaModel,
            type: Backbone.One
        }
    ],
    getAllMetadata: function () {
        return this.get('metadata');
    },
    getMetadata: function (field) {
        return this.get('metadata.' + field);
    },
    add: relayDocuments('add'),
    where: relayDocuments('where'),
    remove: relayDocuments('remove'),
    some: relayDocuments('some'),
    filter: relayDocuments('filter'),
    size: relayDocuments('size'),
    at: relayDocuments('at'),
    each: relayDocuments('each'),
    find: relayDocuments('find'),
    findWhere: relayDocuments('findWhere'),
    first: relayDocuments('first'),
    map: relayDocuments('map'),
    contains: relayDocuments('contains'),
    any: function () {
        return this.size() > 0;
    }
});

module.exports = DocumentList;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/DocumentList.js
// module id = 1620
// module chunks = 64